import { DialogContextProps } from "@interfaces/System/DialogContextProps";
import { Button, DialogActions, DialogContent } from "@material-ui/core";
import { ModalContentLoading } from "@components/Common/Modal";
import React, { useRef } from "react";
import { storeService } from "@services";
import { useSnackbar } from "notistack";
import { useAsync, useTable } from "@hooks";
import { CreateQuantityReserveDto, UpdateQuantityReserveDto } from "@dto/QuantityDto";
import { QuantityReserveForm } from "@components/Forms/Quantity";

const QuantityReserveDialogContext = ({ onClose, modalProps }: DialogContextProps) => {
    const { itemId } = { ...modalProps };

    const formRef = useRef<HTMLFormElement>();
    const { enqueueSnackbar } = useSnackbar();
    const { updateData } = useTable();

    const { data, loadingStatus } = useAsync(storeService.getOneQuantityReserve, {
        functionArgs: [itemId],
        canLoad: !!itemId,
    });

    const invokeSubmit = () => {
        formRef.current!.handleSubmit();
    };

    const handleCreateQuantityReserve = async (values) => {
        try {
            const dto = storeService.plainToClass(CreateQuantityReserveDto, values);
            await storeService.createQuantityReserve(dto);
            enqueueSnackbar("Резерв успешно добавлен", {
                variant: "success",
            });
            onClose();
            updateData();
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при добавлении резерва", {
                variant: "error",
            });
        }
    };

    const handleUpdateQuantityReserve = async (values) => {
        if (!data) return;

        try {
            const dto = storeService.plainToClass(UpdateQuantityReserveDto, values);
            await storeService.updateQuantityReserve(data.id, dto);
            enqueueSnackbar("Резерв успешно обновлен", {
                variant: "success",
            });
            onClose();
            updateData();
        } catch (err) {
            const message = err.response?.data?.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при обновлении резерва", {
                variant: "error",
            });
        }
    };

    return (
        <>
            <DialogContent>
                {loadingStatus === "loading" && <ModalContentLoading />}

                {(loadingStatus === "loaded" || loadingStatus === "inactivity") && (
                    <QuantityReserveForm
                        ref={formRef}
                        data={data}
                        onSubmit={data ? handleUpdateQuantityReserve : handleCreateQuantityReserve}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={onClose}>
                    Отмена
                </Button>
                <Button color="primary" variant="contained" onClick={invokeSubmit}>
                    Сохранить
                </Button>
            </DialogActions>
        </>
    );
};

export default QuantityReserveDialogContext;
